import { useMe, useUITheme } from '@crehana/web';
import DownloadsCertificates from '@crehana/web/HomeUser/Diplomas';

import { DIPLOMAS_URL_SOURCES } from '@/shared/components/Diplomas/constants';

import { USER_DASHBOARD_AMPLITUDE_PAGE_NAME } from '../../constants';

const Diplomas = () => {
  const { me } = useMe();
  const { isDark } = useUITheme();

  return (
    <DownloadsCertificates
      amplitude={{
        source: USER_DASHBOARD_AMPLITUDE_PAGE_NAME,
        sourceDetail: DIPLOMAS_URL_SOURCES.DIPLOMA_CARD,
      }}
      username={me?.username!}
      maxVisibleDiplomas={200}
      isDark={isDark}
    />
  );
};

export default Diplomas;
